import { formatMoney } from '../../lib/money.js';

export interface MoneyProps {
  amount: string;
  currency: string;
  /** Locale; defaults to current i18n locale (resolved by the hook elsewhere). */
  locale: string;
  /** Numbering system: latn (default) or arab. */
  numberingSystem?: 'latn' | 'arab';
  /** True when displaying a converted (non-storage) value. Renders an "≈" prefix. */
  approximate?: boolean;
  className?: string;
}

/**
 * <Money /> renders a server-formatted amount via Intl.NumberFormat. NEVER does math
 * client-side — see ADR-0005.
 */
export function Money(props: MoneyProps): JSX.Element {
  const text = formatMoney(props.amount, {
    locale: props.locale,
    currency: props.currency,
    numberingSystem: props.numberingSystem,
    approximate: props.approximate,
  });
  return <span className={props.className} data-testid="money">{text}</span>;
}
